const types = [
  'top',
  'bottom',
  'left',
  'right',
  'title',
  'text',
  'movie',
  'movie-left',
  'movie-right',
  'anim',
  'anim-left',
  'anim-right',
  'icon',
  'function',
  // 'comparsion', // obsolete? this type was not used since 3 years
]

export default types
